import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { api } from '@/lib/api';
import { KeyRound, Loader2 } from 'lucide-react';

function roleHome(role) {
  if (role === 'super_admin' || role === 'school_admin' || role === 'partner_admin') return '/admin/dashboard';
  if (role === 'teacher') return '/teacher/dashboard';
  return '/student/dashboard';
}

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const forced = !!user?.must_change_password;

  const submit = async (e) => {
    e.preventDefault();
    if (!current || !next || !confirm) { toast.error('Completa todos los campos'); return; }
    if (next.length < 6) { toast.error('La nueva contraseña debe tener al menos 6 caracteres'); return; }
    if (next !== confirm) { toast.error('Las contraseñas no coinciden'); return; }
    if (current === next) { toast.error('La nueva contraseña debe ser distinta a la actual'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/auth/change-password', { current_password: current, new_password: next });
      if (data?.token) localStorage.setItem('c4k_token', data.token);
      await refresh();
      toast.success('Contraseña actualizada');
      nav(roleHome(user?.role), { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al cambiar la contraseña');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
      <Card className="w-full max-w-md border-slate-200">
        <CardHeader>
          <CardTitle className="font-display text-3xl font-extrabold flex items-center gap-2">
            <KeyRound className="w-6 h-6 text-blue-600"/> Cambiar contraseña
          </CardTitle>
          <p className="text-sm text-slate-500">
            {forced
              ? 'Es tu primer inicio de sesión: por seguridad, establece una contraseña personal.'
              : 'Actualiza tu contraseña de acceso.'}
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Contraseña actual</Label>
              <Input data-testid="cp-current" type="password" value={current} onChange={(e)=>setCurrent(e.target.value)} required />
            </div>
            <div>
              <Label>Nueva contraseña</Label>
              <Input data-testid="cp-new" type="password" value={next} onChange={(e)=>setNext(e.target.value)} required minLength={6}/>
            </div>
            <div>
              <Label>Confirmar nueva contraseña</Label>
              <Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e)=>setConfirm(e.target.value)} required minLength={6}/>
            </div>
            <Button data-testid="cp-submit" type="submit" disabled={loading} className="w-full rounded-full bg-blue-600 hover:bg-blue-700 border-b-4 border-blue-800 btn-tactile h-11 font-bold">
              {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin"/> Guardando…</> : 'Guardar contraseña'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
